export const PARENT_DASHBOARD_SET_STUDENT_DISTRICTS = 'PARENT_DASHBOARD_SET_STUDENT_DISTRICTS';
export const PARENT_DASHBOARD_SET_STUDENT_SITES = 'PARENT_DASHBOARD_SET_STUDENT_SITES';
